import queryString from 'query-string'
import dayjs from 'dayjs'
import vitAPI from '../api'
import { handleReceiveNotifications, selectConfigData } from './configuration'
import { handleErrorProperties, handleReceiveProperties } from './properties'
import { handleReceiveCurrencies } from './currencies'
import parseIncomingParams from '../utilities/parseIncomingParams'
import { receivePackages } from './promos'
import { receiveUserData } from './userData'
import fireAnalyticsEvent from '../utilities/analytics/fireAnalyticsEvent'

const utc = require('dayjs/plugin/utc')
const timezone = require('dayjs/plugin/timezone') // dependent on utc plugin

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.tz.setDefault('Australia/Sydney')

const bootstrapApp = () => (dispatch, getState) => {
  const configData = selectConfigData(getState())

  const promises = [
    vitAPI
      .getProperties()
      .catch((err) =>
        dispatch(
          handleErrorProperties(err?.message || 'error fetching properties')
        )
      ),
    vitAPI
      .getCurrencyRates(
        configData?.hotel?.options?.components?.supportedCurrencies || []
      )
      .catch((err) => err),
    vitAPI
      .getPackages()
      .then((res) => {
        dispatch(receivePackages(res))
        return res
      })
      .catch(() => null),
    vitAPI
      .authenticate()
      .then(() => {
        return vitAPI.getUser().then(({ data }) => data)
      })
      .catch(() => null),
    vitAPI
      .getBrands()
      .then(({ data }) => data)
      .catch((err) => {
        if (process.env.NODE_ENV === 'development') {
          console.log(err)
        }
      }),
    vitAPI.getIsInMaintenanceMode().catch(() => {
      // do nothing
    }),
  ]

  return Promise.all(promises).then(
    ([
      properties,
      currencies,
      promos,
      user,
      notifications,
      isInMaintenance,
    ]) => {
      if (isInMaintenance) {
        window.location.href = `${process.env.REACT_APP_ENDPOINT_DRUPAL}/maintenance.html`
        throw new Error('Redirecting...')
      }

      if (properties?.data) {
        const result = properties.data
        if (result.ACG) {
          delete result.ACG
        }
        dispatch(handleReceiveProperties(result))
      } else {
        dispatch(handleErrorProperties('error fetching properties'))
      }
      if (currencies) {
        dispatch(handleReceiveCurrencies(currencies))
      }
      const queryData = queryString.parse(window.location.search)

      const storageKey = queryData?.state
      const validaSearchParams = parseIncomingParams({
        params: queryData,
        properties: properties?.data || {},
        promos,
      })

      if (user) {
        dispatch(receiveUserData(user))
      }

      fireAnalyticsEvent(
        'login_status',
        {
          login_status: !!user,
        },
        user?.roles?.some((role) => role === 'call_center_agent')
      )
      if (notifications) {
        dispatch(handleReceiveNotifications(notifications))
      }

      return {
        searchParams: { ...validaSearchParams, storageKey },
        user,
      }
    }
  )
}

export default bootstrapApp
